"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBoxInputContainer = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../StatusMessage/index.js");
const index_js_2 = require("../utils/index.js");
const helpers_js_1 = require("./helpers.js");
const ComboBoxInputContainer = (props) => {
    const { className, status, message, children, ...rest } = props;
    const { id } = (0, index_js_2.useSafeContext)(helpers_js_1.ComboBoxStateContext);
    return (React.createElement(index_js_2.InputContainer, { className: className, status: status, statusMessage: typeof message === 'string' ? (React.createElement(index_js_1.StatusMessage, { status: status }, message)) : (React.isValidElement(message) &&
            React.cloneElement(message, { status })), ...rest, id: id },
        React.createElement("div", { className: 'iui-input-with-icon' }, children)));
};
exports.ComboBoxInputContainer = ComboBoxInputContainer;
exports.ComboBoxInputContainer.displayName = 'ComboBoxInputContainer';
